"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const FavoriteShiptosModal_1 = __importDefault(require("./FavoriteShiptosModal"));
const FavoriteShiptosModalWrapper = () => {
    const { isFavoriteShiptosModalOpen } = (0, react_redux_1.useSelector)((state) => state.favoriteShiptosModal);
    return isFavoriteShiptosModalOpen ? react_1.default.createElement(FavoriteShiptosModal_1.default, null) : null;
};
exports.default = FavoriteShiptosModalWrapper;
